<template>
  <section v-if="items.length" :id="sectionId" class="event-section details-section">
    <v-container>
      <p class="section-kicker">Details</p>
      <h2>{{ title }}</h2>
      <div class="details-grid">
        <div v-for="item in items" :key="item.label" class="detail-item">
          <span>{{ item.label }}</span>
          <strong>{{ item.value }}</strong>
        </div>
      </div>
    </v-container>
  </section>
</template>

<script>
export default {
  name: 'EventDetailsCard',
  props: {
    title: { type: String, default: 'Event Details' },
    sectionId: { type: String, default: 'details' },
    details: { type: Object, default: () => ({}) },
  },
  computed: {
    items() {
      return Object.entries(this.details)
        .filter(([, value]) => value !== undefined && value !== null && value !== '' && !Array.isArray(value))
        .map(([key, value]) => ({
          label: key.replace(/([a-z])([A-Z])/g, '$1 $2').replace(/\b\w/g, (letter) => letter.toUpperCase()),
          value,
        }));
    },
  },
};
</script>

<style scoped>
.event-section { background: #0b0b0b; padding: 64px 0; }
.section-kicker { color: #e23232; font-family: "Oswald", sans-serif; font-weight: 800; text-transform: uppercase; }
h2 { color: #fff; font-family: "Oswald", sans-serif; font-size: 2.5rem; margin: 0 0 24px; }
.details-grid { display: grid; gap: 12px; grid-template-columns: repeat(auto-fit, minmax(170px, 1fr)); }
.detail-item { background: #131313; border: 1px solid #2d2d2d; border-radius: 10px; padding: 18px; }
.detail-item span { color: #999; display: block; font-size: 0.76rem; font-weight: 800; text-transform: uppercase; }
.detail-item strong { color: #fff; display: block; margin-top: 8px; }
</style>
